
import { Outlet, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { AppSidebar } from "@/components/app-sidebar"
import { IntercomProvider } from "@/components/intercom-provider"
import { useAuth } from "@/lib/auth-context"

export default function DashboardLayout() {
  const { user, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !user) {
      // Check if there's a token cookie as a fallback
      const hasToken = document.cookie.includes("irene_token=")
      if (!hasToken) {
        console.log("[DashboardLayout] No user and no token, redirecting to login")
        navigate("/login")
      } else {
        console.log("[DashboardLayout] No user object but token exists, allowing dashboard access")
      }
    }
  }, [user, isLoading, navigate])

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <AppSidebar />
      <main className="flex-1 overflow-auto bg-background">
        <Outlet />
      </main>
      <IntercomProvider />
    </div>
  )
}
